import { Wrench, Sparkles, PenTool, Building2, MapPin, Package, Crosshair, Layers } from "lucide-react";
import { Reveal } from "./Reveal";
import { scrollToId } from "../data/site";

const PILLARS = [
  { icon: Wrench, title: "Professional Installation", desc: "Certified applicators, controlled environment, factory-spec technique.", testid: "why-choose-pillar-1" },
  { icon: Sparkles, title: "Clean & Precise Workmanship", desc: "Tucked edges, flawless cuts and bubble-free finishes as standard.", testid: "why-choose-pillar-2" },
  { icon: PenTool, title: "Creative Design & Concepts", desc: "In-house designers develop your concept before anything is printed.", testid: "why-choose-pillar-3" },
  { icon: Building2, title: "Residential & Commercial", desc: "Homes, offices, shopfronts and fleets — one studio for all of it.", testid: "why-choose-pillar-4" },
  { icon: MapPin, title: "Melbourne & Surrounds", desc: "Mobile and in-studio service across greater Melbourne.", testid: "why-choose-pillar-5" },
  { icon: Package, title: "Design + Supply + Install", desc: "One accountable team from first sketch to final squeegee pass.", testid: "why-choose-pillar-6" },
  { icon: Crosshair, title: "Attention to Detail", desc: "We obsess over the millimetres so the metres look effortless.", testid: "why-choose-pillar-7" },
  { icon: Layers, title: "Print, Vinyl & Film Experience", desc: "Practical, hands-on experience across every material we install.", testid: "why-choose-pillar-8" },
];

export default function WhyChooseUs() {
  return (
    <section className="relative bg-[#0A0A0A] py-20 lg:py-28 overflow-hidden">
      <div className="absolute right-0 top-0 w-[420px] h-[420px] rounded-full bg-[#FF2A2A]/10 blur-[140px]" />
      <div className="container-x grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <Reveal>
          <div className="eyebrow mb-4">WHY CHOOSE US</div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold uppercase tracking-tight leading-[0.95] mb-10">
            Built on craft, <span className="text-gradient">backed by detail</span>
          </h2>
          <div className="grid sm:grid-cols-2 gap-x-8 gap-y-7">
            {PILLARS.map((p) => (
              <div key={p.title} data-testid={p.testid} className="group">
                <div className="flex items-center gap-3 mb-2">
                  <span className="w-9 h-9 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center text-[#FF6B00] group-hover:border-[#FF6B00]/50 group-hover:bg-[#FF6B00]/10 transition-colors duration-200">
                    <p.icon size={16} />
                  </span>
                  <h3 className="font-sub font-bold text-sm uppercase tracking-wide">{p.title}</h3>
                </div>
                <p className="text-zinc-500 text-xs leading-relaxed pl-12">{p.desc}</p>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="relative">
            <div className="absolute -inset-3 rounded-3xl bg-gradient-to-br from-[#FF2A2A]/30 to-[#FF6B00]/10 blur-xl" />
            <div className="relative rounded-2xl overflow-hidden border border-white/10">
              <img
                src="/images/why-choose.webp"
                alt="vicwrap studio installer draping carbon fibre vinyl over a car fender"
                loading="lazy"
                className="w-full h-[420px] sm:h-[520px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 right-6 flex items-end justify-between gap-4">
                <div>
                  <div className="font-display text-4xl font-extrabold leading-none">UP TO 5YR</div>
                  <div className="font-tech text-[10px] uppercase tracking-[0.2em] text-zinc-400 mt-1">
                    Film & workmanship warranty
                  </div>
                </div>
                <button data-testid="why-choose-quote-button" onClick={() => scrollToId("quote")} className="btn-primary !px-4 !py-2.5 text-xs shrink-0">
                  FREE QUOTE
                </button>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
